<template>
	<div>
		<box :customer="true" :autoLoad="false" :ref="boxRef" title="万里牛订单" :width="1000" :index="0" @hide="hide" @submit="submit"
			moduleName="online" :store="store" selectType="checkbox"
			@boxdataload="boxdataload" />

	</div>
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	//https://detail.tmall.com/item.htm?id=706822484836&spm=a21dvs.23580594.0.0.1d293d0d88sla5 
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey:{relation:'collection'},
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						type:"checkbox",
						field: 'salesmanName',
						title: '业务员',
						render: '',
					},{
						field: 'salercpt_no',
						title: '系统单号',
						render: '$input',
					}, {
						field: 'show_buyer',
						title: '买家ID',
						render: '$input',
					}, {
						field: 'tp_payment',
						title: '应收款',
						// formatter: ({
						// 	cellValue
						// }) => {
						// 	return window.systemMethods.timestampToDate(cellValue)
						// }
					}, {
						field: 'tp_pay_time',
						title: '下单时间',
						render: '$datePicker',
					}, {
						field: 'orderamount',
						title: '收款金额',
					}, {
						field: 'code',
						title: '关联单据',
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 100,
						enabled: true,
						pageSizes: [100, 200, 500,1000],
						force:false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list

		},
		watch: {

		},
		computed: {

		},

		methods: {
			initList() {
				if(!this.box.gridOptions){
					this.box.initBox(this.boxConfig)
				}
				
				
			},
			list(page, form, other) {
				return new Promise((resolve,reject) => {					
					this.$api.wlnorder.list({
						mode: 'box',
						index: this.index,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>
